import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { PROJECTS } from "../data/site";

const ALL_PROJECTS = [
  ...PROJECTS,
  { t: "A Middle Eastern Hospitality Group", brief: "Custom block-printed linen for 8 boutique properties.", img: "https://images.pexels.com/photos/32795059/pexels-photo-32795059.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", type: "Hospitality · UAE" },
  { t: "A Canadian Home Brand",              brief: "Ongoing supply of cushions and throws across 24 SKUs.", img: "https://images.pexels.com/photos/36013228/pexels-photo-36013228.png?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",  type: "Retail · Canada" },
];

export default function Projects() {
  return (
    <main data-testid="projects-page" className="pt-28">
      <section className="py-16 md:py-24 bg-[#faf6ef]">
        <div className="max-w-[1100px] mx-auto px-6 md:px-10 text-center">
          <div className="text-[#b4462a] text-xs tracking-[0.3em] uppercase mb-4">Projects & Case Studies</div>
          <h1 className="font-serif text-5xl md:text-7xl leading-[1.05] tracking-tight font-light">Quiet work, proudly anonymised where needed.</h1>
          <p className="mt-6 text-lg text-[#1a1a1a]/70 max-w-2xl mx-auto leading-[1.8]">Hospitality groups, retail chains, royalty, concept stores. A selection below; most of our NDA-bound work never makes it to this page.</p>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-white">
        <div className="max-w-[1440px] mx-auto px-6 md:px-10 lg:px-14 grid md:grid-cols-2 gap-6 md:gap-10">
          {ALL_PROJECTS.map((p, i) => (
            <motion.article key={p.t + i} initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.7, delay: i * 0.05 }} className={`group ${i % 3 === 0 ? "md:col-span-2" : ""}`} data-testid={`project-${i}`}>
              <div className="relative overflow-hidden aspect-[16/10]">
                <img src={p.img} alt={p.t} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <div className="mt-5">
                <div className="text-[#b4462a] text-[11px] tracking-[0.25em] uppercase mb-2">{p.type}</div>
                <div className="font-serif text-2xl text-[#1a1a1a]">{p.t}</div>
                <div className="text-sm text-[#1a1a1a]/70 mt-2 max-w-xl leading-[1.7]">{p.brief}</div>
              </div>
            </motion.article>
          ))}
        </div>
      </section>

      <section className="py-24 bg-[#b4462a] text-[#faf6ef] text-center">
        <div className="max-w-[900px] mx-auto px-6">
          <h2 className="font-serif text-4xl md:text-5xl leading-[1.1] font-light mb-6">Ready to see your project here?</h2>
          <Link to="/contact#lead-form" className="inline-flex items-center gap-2 bg-[#faf6ef] text-[#1e2a5a] hover:bg-[#1e2a5a] hover:text-[#faf6ef] px-8 py-4 text-xs tracking-[0.25em] uppercase transition" data-testid="projects-cta">
            Start a project <ArrowRight size={14} strokeWidth={1.5} />
          </Link>
        </div>
      </section>
    </main>
  );
}
